import {createEntityMeta,SyncStatus} from '../offline/entity.js';
import {createLiveEvent,orderLiveEvents} from './live-event.js';

export const LIVE_EVENT_ENTITY_TYPE='live_event';

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

export function createLiveEventStore({
  repository,
  queue,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.list||!repository?.put)throw new TypeError('repository with get/list/put is required');
  if(!queue?.enqueue)throw new TypeError('sync queue is required');
  const owner=required(userId,'userId');

  async function get(id){
    const row=await repository.get(LIVE_EVENT_ENTITY_TYPE,required(id,'id'));
    if(!row)return null;
    if(row.userId!==owner)throw new Error('LIVE_EVENT_OWNER_MISMATCH');
    return Object.freeze(row);
  }

  async function list(sessionId,{eventType=null}={}){
    const session=required(sessionId,'sessionId');
    const rows=await repository.list(LIVE_EVENT_ENTITY_TYPE);
    const owned=(rows||[])
      .filter(row=>row.userId===owner&&row.sessionId===session)
      .filter(row=>!eventType||row.eventType===eventType);
    const ordered=orderLiveEvents(owned);
    const byId=new Map(owned.map(row=>[row.id,row]));
    return Object.freeze(ordered.map(value=>Object.freeze({...byId.get(value.id),...value})));
  }

  async function append(sessionId,input={}){
    const session=required(sessionId,'sessionId');
    const event=createLiveEvent({
      ...input,
      userId:owner,
      sessionId:session,
      occurredAt:input.occurredAt||now()
    });
    const existing=await repository.get(LIVE_EVENT_ENTITY_TYPE,event.id);
    if(existing)throw new Error('LIVE_EVENT_ALREADY_EXISTS');
    const entity={
      ...createEntityMeta({id:event.id,now:now(),syncStatus:SyncStatus.PENDING_CREATE}),
      ...event
    };
    return queue.enqueue(LIVE_EVENT_ENTITY_TYPE,entity,'create');
  }

  return Object.freeze({append,get,list});
}
